import React, { useEffect, useState } from "react";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DatePicker } from "antd";
import dayjs from "dayjs";

const UserTable = ({
  data,
  selectedStatus,
  handleStatusChange,
  activeTab,
  startDate,
  endDate,
  handleDateRangeChange,
  handleResetFilters,
  loading,
}: any) => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { RangePicker } = DatePicker;

  const columns = [
    { header: "", accessor: "profilePhoto" },
    {
      header: activeTab === "merchant" ? "Business Name" : "Name",
      accessor: "fullname",
      render: (row: any) => (
        <span className='inline-flex items-center gap-1'>
          {row.fullname}
          {row.isMarketer && (
            <span
              title='Sales Associate'
              className='text-[9px] font-bold text-white bg-[#0979A1] rounded px-1 leading-4'>
              S
            </span>
          )}
        </span>
      ),
      
    },
    { header: "Email Address", accessor: "email" },
    { header: "Phone No", accessor: "phone" },
    { header: "Status", accessor: "status" },
    { header: "Date Joined", accessor: "created_at" },
    { header: " ", accessor: "id" },
  ];

  useEffect(() => {
    const filtered = data.filter((user: any) => {
      if (user.status) {
        return true;
      }
      return false;
    });
    setFilteredData(filtered);
    setIsLoading(false);
  }, [data, selectedStatus, startDate, endDate]);

  const handleUserClick = (id: string) => {
    navigate(`/account/details/${id}`);
  };

  return (
    <div className='rounded-md py-3 px-3 bg-white border border-[#fff] mt-10 w-[95%] pt-5 '>
      <div className='flex justify-between'>
        <p className='text-[18px] font-semibold'>All Accounts</p>
        <section className='flex gap-2'>
          <div>
            <span className='text-[14px] font-medium'>Filter by:</span>
            <select
              className='border text-[12px] px-3 py-1 rounded bg-[#0979A1] text-white'
              value={selectedStatus}
              onChange={handleStatusChange}>
              <option value=''>All</option>
              <option value='active'>Active</option>
              <option value='suspended'>Suspended</option>
              <option value='inactive'>Inactive</option>
              <option value='blocked'>Blocked</option>
            </select>
          </div>
          <div className=''>
            <RangePicker
              value={[
                startDate ? dayjs(startDate) : null,
                endDate ? dayjs(endDate) : null,
              ]}
              onChange={(dates) => handleDateRangeChange(dates)}
            />
            <button
              className='border text-[12px] px-2 py-1.5 ml-2 rounded bg-[#FF4D4F] text-white'
              onClick={() =>
                handleResetFilters
                  ? handleResetFilters()
                  : handleDateRangeChange([null, null])
              }>
              Reset
            </button>
          </div>
        </section>
      </div>

      {loading || isLoading ? (
        <div className='flex justify-center items-center h-64'>
          <TailSpin color='skyblue' />
        </div>
      ) : filteredData.length > 0 ? (
        <Table
          columns={columns}
          data={filteredData}
          selectedUserId={null}
          onUserClick={handleUserClick}
        />
      ) : (
        <div className='flex justify-center items-center h-64'>
          <p className='text-gray-500 text-lg'>No data available</p>
        </div>
      )}
    </div>
  );
};

export default UserTable;
